const activationCodeEntryTemplate = `<pwr-mfa></pwr-mfa>`;
export default activationCodeEntryTemplate;
